var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionMonthlyMapUpdatesColoredDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM19 8H5V19H19V8Z",
    fill: "#5714CC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1H6V3H8V1Z",
    fill: "#5714CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 1H16V3H18V1Z",
    fill: "#5714CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8H19V19H5V8Z",
    fill: "#5714CC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10V12H9V10H7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10V12H13V10H11Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12V10H17V12H15Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14V16H9V14H7Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16V14H13V16H11Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14V16H17V14H15Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12L7 10L9 10V12H7Z",
    fill: "#FFC30D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17C24 20.866 20.866 24 17 24C13.134 24 10 20.866 10 17C10 13.134 13.134 10 17 10C20.866 10 24 13.134 24 17Z",
    fill: "#FFC30D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17H17L20 20L23 17H21C21 14.7909 19.2091 13 17 13C14.7909 13 13 14.7909 13 17C13 19.2091 14.7909 21 17 21V19Z",
    fill: "#5714CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionMonthlyMapUpdatesColoredDay);
export default __webpack_public_path__ + "static/media/ic_action_monthly_map_updates_colored_day.c9d62f2dbdc04bc32eeeb97768f8705a.svg";
export { ForwardRef as ReactComponent };